import { Injectable, inject } from '@angular/core';
import { Observable, filter, tap } from 'rxjs';
import { ResourceFacade } from '~backoffice/app/~store/facades/resource.facade';
import { User } from '~core/models/core.models';
import { DeleteConfirmComponent } from '../components/modals/delete-confirm/delete-confirm.component';
import { SnackbarService } from './snackbar.service';
import { UserService } from '~backoffice/app/~shared/services/user.service';
import { DialogService } from '~core/services/dialog.service';

@Injectable()
export class UserManagementService {
  private resourceFacade = inject(ResourceFacade);
  private userService = inject(UserService);

  constructor(
    private snackBar: SnackbarService,
    private dialogService: DialogService
  ) {}

  delete(user: User): Observable<unknown> {
    const delete$ = this.userService.delete(user.id);
    const dialogRef = this.dialogService.open({
      component: DeleteConfirmComponent,
      config: {
        panelClass: ['mat-dialog-custom'],
        disableClose: true
      }
    });

    dialogRef.componentRef?.setInput('removeObservable$', delete$);
    dialogRef.componentRef?.setInput('wordEntry', user.email);

    return dialogRef.afterClosed().pipe(
      filter(Boolean),
      tap({
        next: () => {
          this.resourceFacade.getData({ refresh: true });
          this.snackBar.open({
            text: 'Utilisateur supprimé',
            type: 'success'
          });
        }
      })
    );
  }

  lock(user: User): Observable<User> {
    const newData = {
      locked: true
    };
    return this.userService.update(user.id, newData).pipe(
      tap({
        next: () => {
          this.resourceFacade.patchItem({
            item: user,
            newData
          });
          this.snackBar.open({
            text: 'Utilisateur bloqué',
            type: 'success'
          });
        }
      })
    );
  }

  unLock(user: User): Observable<unknown> {
    const delete$ = this.userService.update(user.id, {
      locked: false
    });
    const dialogRef = this.dialogService.open({
      component: DeleteConfirmComponent,
      config: {
        panelClass: ['mat-dialog-custom'],
        disableClose: true
      }
    });

    dialogRef.componentRef?.setInput('removeObservable$', delete$);
    dialogRef.componentRef?.setInput('wordEntry', 'Je confirme');
    dialogRef.componentRef?.setInput(
      'title',
      'Voulez-vous débloquer cet utilisateur ?'
    );
    dialogRef.componentRef?.setInput(
      'instruction',
      `Veuillez saisir le texte ci-dessous pour confirmer`
    );
    dialogRef.componentRef?.setInput('action', 'Débloquer');

    return dialogRef.afterClosed().pipe(
      filter(Boolean),
      tap({
        next: () => {
          this.resourceFacade.patchItem({
            item: user,
            newData: {
              locked: false
            }
          });
          this.snackBar.open({
            text: 'Utilisateur débloqué',
            type: 'success'
          });
        }
      })
    );
  }

  toggleLockState(user: User): Observable<unknown> {
    return user.locked ? this.unLock(user) : this.lock(user);
  }
}
